// components/FilteredInput.jsx
import React from 'react';
import { Input } from 'antd';
import { filterIndianLanguages } from '../utils/filterIndianLanguages';

const FilteredInput = ({ value, onChange, ...rest }) => {
  const handleChange = (e) => {
    const cleanedValue = filterIndianLanguages(e.target.value);
    onChange && onChange({ target: { value: cleanedValue } });
  };

  return <Input {...rest} value={value} onChange={handleChange} />;
};

export default FilteredInput;
